import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { Plan, PromotionModel } from '@bytel/bytel-sales';
import {
    GalliumPrice,
    GalliumPrices,
    GalliumService,
    RenewalPlanPricesDetails,
    User,
    UserService,
} from '@bytel/checkout';

import { MainCartService } from '@services/main-cart.service';
import { MixedCartService } from '@services/mixed-cart.service';

import { PriceInitialPipe } from '../../../../../../shared/pipes/price-initial.pipe';
import { PriceComponent } from '../../../../../../trilogy/price/price.component';

@Component({
    selector: 'checkout-prices-block',
    templateUrl: './prices-block.component.html',
    styleUrl: 'prices-block.component.scss',
    standalone: true,
    imports: [NgClass, PriceComponent, PriceInitialPipe],
})
export class PricesBlockComponent implements OnInit {
    @Input() public subscription: Plan;
    @Input() public quoteIndex: number = 0;
    @Input() public uniqOffer: boolean = false;
    @Input() public displayConnectLink: boolean = true;
    @Input() public isInlined: boolean = true;
    @Input() public subscriptionBlock: boolean = false;
    @Input() public promoAmount: number = 0;

    public refundsList: GalliumPrice[] = [];
    public renewalPrices: RenewalPlanPricesDetails;
    public isRenewal: boolean = false;
    public incitationPromo: PromotionModel;
    public user: User;
    public isMixedCart: boolean = false;
    public constructor(
        private cartService: MainCartService,
        private galliumService: GalliumService,
        private userService: UserService,
        private mixedCartService: MixedCartService,
    ) {}

    public ngOnInit(): void {
        const quote = this.cartService.getQuote(this.quoteIndex);
        this.isRenewal = quote?.isRenewal();
        if (this.isRenewal) {
            this._getRenewalPrices();
        }
        this.isMixedCart = this.mixedCartService.isMixedCart(this.cartService.cartModel);
        this.user = this.userService.user;
        const incitationsPromo: PromotionModel[] = this.subscription.promotions.incitation;
        this.incitationPromo = incitationsPromo.length > 0 ? incitationsPromo[0] : null;
    }

    private _getRenewalPrices(): void {
        const galliumPrices: GalliumPrices = this.galliumService.getGalliumPrices(this.subscription?.data?.gencode);
        this.refundsList = galliumPrices ? galliumPrices.refundsList || [] : [];
        if (galliumPrices) {
            this.renewalPrices = {
                base: galliumPrices.price,
                final: galliumPrices.promoPrice ?? galliumPrices.price,
                temporary: galliumPrices.promoPrice ?? galliumPrices.price,
                duration: null,
            };

            this.refundsList.forEach((refundElement: GalliumPrice) => {
                if (refundElement.duration) {
                    this.renewalPrices.duration = refundElement.duration;
                    this.renewalPrices.durationLabel = refundElement.promoLabel;
                    this.renewalPrices.final = Number((this.renewalPrices.final - refundElement.amount).toFixed(2));
                }
            });
        }
    }
}
